import { atom } from 'recoil';

type Filter = {
  type: string;
  label: string;
};

const filterAtom = atom<Array<Filter>>({
  key: 'atom/filter',
  default: [
    { type: 'abo', label: '혈액형' },
    { type: 'bloodProduct', label: '헌혈 종류' },
    { type: 'sortBy', label: '최신순' },
  ],
});

export default filterAtom;
